import { render } from "./AddVehicleToDepartment.vue?vue&type=template&id=4611dc9c&scoped=true&ts=true"
import script from "./AddVehicleToDepartment.vue?vue&type=script&lang=ts"
export * from "./AddVehicleToDepartment.vue?vue&type=script&lang=ts"

import "./AddVehicleToDepartment.vue?vue&type=style&index=0&id=4611dc9c&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4611dc9c"]])

export default __exports__